// extracted by mini-css-extract-plugin
module.exports = {"container":"ShippingRegistration_container__2S6zL"};